import { VIcon } from "vuetify/lib";
import Vue, { VNode } from "vue";

const ListAction = Vue.extend({
  props: { text: { type: String, default: "" } },
  render(h): VNode {
    return h(
      "div",
      {
        class: ["d-flex align-center primary--text"]
      },
      [
        h("span", { class: ["body-2"] }, this.text),
        h(
          VIcon,
          { props: { size: "20", color: "primary" } },
          this.$icons.mdiChevronRight
        )
      ]
    );
  }
});

export default ListAction;
